/* ZilZal - header game picker list, collection search, and label tagging.

   CSS cannot select an element by its text, so anything that has to be matched
   by label is tagged here and hidden by CSS. */
(function () {
  'use strict';

  var FILTER_WORDS = ['\u0641\u0644\u062a\u0631', '\u0645\u0631\u0634\u062d\u0627\u062a'];
  var GAME_LABEL = '\u0627\u062e\u062a\u064a\u0627\u0631 \u0627\u0644\u0644\u0639\u0628\u0629';

  function markCurrent(picker) {
    var path = decodeURIComponent(window.location.pathname);
    var items = picker.querySelectorAll('[data-zzgp-url]');
    for (var i = 0; i < items.length; i++) {
      var url = decodeURIComponent(items[i].getAttribute('data-zzgp-url') || '');
      var parts = url.split('/collections/');
      if (parts.length < 2) continue;
      var handle = parts[1].split('?')[0].split('#')[0];
      if (!handle || path.indexOf(handle) === -1) continue;
      items[i].classList.add('is-current');
      var lbl = picker.querySelector('[data-zzgp-label]');
      var thumb = picker.querySelector('[data-zzgp-thumb]');
      var nameEl = items[i].querySelector('span:last-child');
      var img = items[i].querySelector('img');
      if (lbl && nameEl) lbl.textContent = nameEl.textContent.trim();
      if (thumb && img) {
        thumb.textContent = '';
        var t = document.createElement('img');
        t.src = img.getAttribute('src');
        t.alt = '';
        thumb.appendChild(t);
      }
      break;
    }
  }

  function buildPickerList() {
    var picker = document.getElementById('zzgamepick');
    if (!picker) return;
    var list = picker.querySelector('[data-zzgp-list]') || picker.querySelector('.zzgp__panel');
    if (!list || list.querySelector('[data-zzgp-url]')) return;
    var source = document.querySelectorAll('#zzmenu .zzm__game');
    if (!source.length) return;
    var all = list.querySelector('.zzgp__all');
    var frag = document.createDocumentFragment();
    Array.prototype.forEach.call(source, function (a) {
      var href = a.getAttribute('href') || '';
      if (!href || href === '#') return;
      var nameEl = a.querySelector('.zzm__game-name');
      var name = nameEl ? nameEl.textContent.trim() : '';
      var img = a.querySelector('img.zzm__ic');
      var item = document.createElement('a');
      item.className = 'zzgp__item';
      item.href = href;
      item.setAttribute('data-zzgp-url', href);
      item.setAttribute('data-zzgp-name', name.toLowerCase());
      if (img) {
        var im = document.createElement('img');
        im.src = img.getAttribute('src');
        im.alt = '';
        im.loading = 'lazy';
        item.appendChild(im);
      } else {
        var ph = document.createElement('span');
        ph.className = 'zzgp__ph';
        ph.textContent = name.charAt(0) || '?';
        item.appendChild(ph);
      }
      var lab = document.createElement('span');
      lab.textContent = name;
      item.appendChild(lab);
      frag.appendChild(item);
    });
    if (all) list.insertBefore(frag, all);
    else list.appendChild(frag);
    markCurrent(picker);
  }

  function makeSearch(bar) {
    if (!bar) return;
    /* Speed (Oct 2026): sections/collection-shelves.liquid now draws the box itself (text from the
       locale files), so it is in the first paint instead of pushing the toolbar and grid down ~50px
       when this script ran. Here it only gets its behaviour. A bar without one is still built as before. */
    var wrap = bar.querySelector('.zzcs');
    if (wrap && wrap.__zzWired) return;
    var isAr = (document.documentElement.lang || 'ar').toLowerCase().indexOf('ar') === 0;
    var input;
    if (wrap) {
      input = wrap.querySelector('input');
      if (!input) return;
    } else {
      wrap = document.createElement('div');
      wrap.className = 'zzcs';

      var ns = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      var c = document.createElementNS(ns, 'circle');
      c.setAttribute('cx', '11'); c.setAttribute('cy', '11'); c.setAttribute('r', '7');
      c.setAttribute('stroke', 'currentColor'); c.setAttribute('stroke-width', '2');
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', 'm20 20-3.2-3.2');
      p.setAttribute('stroke', 'currentColor'); p.setAttribute('stroke-width', '2');
      p.setAttribute('stroke-linecap', 'round');
      svg.appendChild(c); svg.appendChild(p);
      wrap.appendChild(svg);

      input = document.createElement('input');
      input.type = 'search';
      input.autocomplete = 'off';
      input.placeholder = isAr ? 'ابحث عن عناصر' : 'Search items';
      wrap.appendChild(input);
      bar.insertBefore(wrap, bar.firstChild);
    }
    wrap.__zzWired = true;

    /* Oct 2026: live results under the box (picture, name, price) instead of hiding cards in
       the grid. Built from the cards already on the page — no network request, nothing runs
       until the visitor types. Arabic spelling variants (أ/إ/آ, ة/ه, ى/ي) and the English
       product address (e.g. "harvester") both match. */
    var emptyText = input.getAttribute('data-empty') || (isAr ? 'لا توجد نتائج' : 'No results');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    var drop = document.createElement('div');
    drop.className = 'zzcs__drop';
    drop.setAttribute('role', 'listbox');
    drop.hidden = true;
    wrap.appendChild(drop);

    var index = null, hl = -1, shown = [];
    function norm(t) {
      return String(t || '').toLowerCase()
        .replace(/[ً-ٰٟـ]/g, '')
        .replace(/[أإآٱ]/g, 'ا')
        .replace(/ة/g, 'ه').replace(/ى/g, 'ي')
        .replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
    }
    function buildIndex() {
      var seen = {};
      index = [];
      Array.prototype.forEach.call(document.querySelectorAll('[data-bxc-card]'), function (card, i) {
        var link = card.querySelector('a[href*="/products/"]');
        var t = card.querySelector('.bxc-card__title');
        if (!link || !t) return;
        var url = link.getAttribute('href');
        if (seen[url]) return;
        seen[url] = 1;
        var handle = (url.split('/products/')[1] || '').split(/[?#]/)[0];
        try { handle = decodeURIComponent(handle); } catch (x) {}
        var name = t.textContent.trim();
        var img = card.querySelector('.bxc-card__media img');
        var src = img ? (img.getAttribute('src') || '') : '';
        if (src) src = /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=96') : src;
        index.push({ card: card, url: url, name: name, key: norm(name + ' ' + handle), nk: norm(name), src: src, oos: !!card.querySelector('.bxc-card__oos'), i: i });
      });
    }
    function priceHTML(card) {
      var now = card.querySelector('.bxc-now');
      if (!now) return '';
      var tw = now.querySelector('.zz-px');
      if (tw) return tw.outerHTML;
      var span = document.createElement('span');
      span.textContent = now.textContent.trim();
      return span.innerHTML;
    }
    function search(q) {
      var nq = norm(q);
      if (!nq) return [];
      var words = nq.split(' ');
      var res = [];
      index.forEach(function (it) {
        for (var w = 0; w < words.length; w++) { if (it.key.indexOf(words[w]) === -1) return; }
        var score = it.nk.indexOf(nq) === 0 ? 0 : (it.key.indexOf(' ' + words[0]) !== -1 || it.key.indexOf(words[0]) === 0 ? 1 : 2);
        res.push({ it: it, score: score + (it.oos ? 3 : 0) });
      });
      res.sort(function (a, b) { return a.score - b.score || a.it.i - b.it.i; });
      return res.slice(0, 8).map(function (r) { return r.it; });
    }
    function setHl(n) {
      var items = drop.querySelectorAll('.zzcs__item');
      if (hl > -1 && items[hl]) items[hl].classList.remove('is-hl');
      hl = n;
      if (hl > -1 && items[hl]) { items[hl].classList.add('is-hl'); items[hl].scrollIntoView({ block: 'nearest' }); }
    }
    function close() { drop.hidden = true; input.setAttribute('aria-expanded', 'false'); hl = -1; }
    function render() {
      var q = input.value.trim();
      if (!q) { close(); drop.textContent = ''; return; }
      if (!index) buildIndex();
      shown = search(q);
      hl = -1;
      if (!shown.length) {
        drop.innerHTML = '<div class="zzcs__empty"></div>'; drop.firstChild.textContent = emptyText;
      } else {
        var html = '';
        shown.forEach(function (it) {
          var rc = (getComputedStyle(it.card).getPropertyValue('--rar-c') || '').trim();
          html += '<a class="zzcs__item' + (it.oos ? ' is-oos' : '') + '" role="option" href="' + it.url.replace(/"/g, '&quot;') + '">'
            + '<span class="zzcs__thumb"' + (rc ? ' style="--rar-c:' + rc + '"' : '') + '>' + (it.src ? '<img src="' + it.src.replace(/"/g, '&quot;') + '" alt="" width="40" height="40" decoding="async">' : '') + '</span>'
            + '<span class="zzcs__name"></span>'
            + '<span class="zzcs__price">' + priceHTML(it.card) + '</span></a>';
        });
        drop.innerHTML = html;
        Array.prototype.forEach.call(drop.querySelectorAll('.zzcs__name'), function (el, k) { el.textContent = shown[k].name; });
      }
      drop.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    var raf = 0;
    input.addEventListener('input', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { raf = 0; render(); });
    });
    input.addEventListener('focus', function () { if (input.value.trim()) render(); });
    input.addEventListener('keydown', function (e) {
      var n = shown.length;
      if (e.key === 'ArrowDown') { if (n) { e.preventDefault(); setHl((hl + 1) % n); } }
      else if (e.key === 'ArrowUp') { if (n) { e.preventDefault(); setHl(hl <= 0 ? n - 1 : hl - 1); } }
      else if (e.key === 'Enter') { if (n) { e.preventDefault(); var items = drop.querySelectorAll('.zzcs__item'); var a = items[hl > -1 ? hl : 0]; if (a) a.click(); } }
      else if (e.key === 'Escape') { close(); input.blur(); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
  }

  function placeCollectionSearch() {
    makeSearch(document.querySelector('.bxc-topbar'));
    makeSearch(document.querySelector('.bxc-mobilebar'));
  }

  function tagFilterButton() {
    var bars = document.querySelectorAll('.bxc-topbar, .bxc-mobilebar');
    Array.prototype.forEach.call(bars, function (bar) {
      Array.prototype.forEach.call(bar.querySelectorAll('button, a, [role=button]'), function (el) {
        if (el.hasAttribute('data-zz-filterbtn')) return;
        var txt = (el.textContent || '').trim();
        for (var i = 0; i < FILTER_WORDS.length; i++) {
          if (txt.indexOf(FILTER_WORDS[i]) !== -1) {
            el.setAttribute('data-zz-filterbtn', '1');
            return;
          }
        }
      });
    });
  }

  /* The game chooser heading inside the filter rail. The :has() rule did not
     match it, so it is found by its text and its whole group is tagged. */
  function tagGameLabel() {
    var rail = document.querySelector('.bxc-side');
    if (!rail) return;
    var nodes = rail.querySelectorAll('h1, h2, h3, h4, h5, h6, div, span, p, label');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.hasAttribute('data-zz-gamelabel')) return;
      var txt = (el.textContent || '').trim();
      if (txt !== GAME_LABEL) return;
      /* Tag the label and the group wrapping it, so no empty block is left. */
      el.setAttribute('data-zz-gamelabel', '1');
      var group = el.closest('.bxc-fgroup');
      if (group) group.setAttribute('data-zz-gamelabel', '1');
      else {
        var sib = el.nextElementSibling;
        if (sib && !sib.querySelector('input, select')) sib.setAttribute('data-zz-gamelabel', '1');
      }
    });
  }

  function boot() {
    buildPickerList();
    placeCollectionSearch();
    tagFilterButton();
    tagGameLabel();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', boot);
  setTimeout(boot, 600);
  setTimeout(boot, 1600);
})();
